import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import { withRouter, Link } from 'react-router-dom';

import membershipStore from '../../stores/membershipStore';
import Loader from '../../components/Loader';
import UserSubscriptionListing from './components/UserSubscriptionListing';
import MembershipListing from './components/MembershipListing';
import Col12 from './components/Col12';
import BillingFormMembership from '../../components/billing-form/BillingFormMembership';
import Cart from './components/Cart';
import { T } from '../../stores/textStore';
import CreditCardChangeForm from '../../components/billing-form/CreditCardChangeForm';


class CreditCardChangeView extends Component {
	componentDidMount() {		
		membershipStore.alerts.replace([]);		
	}

	render() {		
		if (!membershipStore.isDataLoaded()) {
			return (
				<Col12>
					<Loader message={membershipStore.processingMessage.get()} />
				</Col12>
			);
		}
		const { history } = this.props;
		/*if (membershipStore.creditCardChangeFormProcessSuccess.get()) {
			history.push('/');
			return null;
		}*/
		return (
			<div className="container">
				<div className="row">									
					<div className="col-lg-8">			
						<h2 className="font-weight-bold mt-3">
							{T('Payment Preferences')}
						</h2>		
						<div className="card mt-5 rounded-0">
							<div className="card-body">
								<h6 className="font-weight-bold">{T('Your current card')}</h6>		
								<ul className="list-group">
									<li className="list-group-item list-group-item-secondary rounded-0">
										<strong>{membershipStore.storedCc.paymentmethod}</strong>
										&nbsp;{T('ending in')}&nbsp;
										{membershipStore.storedCc.ccnumber.substring(membershipStore.storedCc.ccnumber.length - 4)}
									</li>
								</ul>
							</div>
						</div>			
						<h5 className="font-weight-bold mt-5">
							{T('Use this form to enter a new credit or debit card')} 							
						</h5>											
						<h6 className="text-muted mt-0">{T('The new card will replace your current card for future membership payments.')}</h6>
					</div>																						
				</div>
				<div className="mt-4">
					<CreditCardChangeForm />
				</div>
			</div>
		);		
	}
}

export default withRouter(observer(CreditCardChangeView));



// WEBPACK FOOTER //
// ./src/views/membership/CreditCardChangeView.js